import { render, staticRenderFns } from "./AddEditEmi.vue?vue&type=template&id=37095568&scoped=true"
import script from "./AddEditEmi.vue?vue&type=script&lang=js"
export * from "./AddEditEmi.vue?vue&type=script&lang=js"
import style0 from "./AddEditEmi.vue?vue&type=style&index=0&id=37095568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37095568",
  null
  
)

export default component.exports